export class Document {
    documentId: string
    title: string
    content: string
}
